//@flow
import {DMS_ERROR, DMS_ORDER_GET_BY_ID, DMS_ORDERS} from "../../dms/action";
import type {DmsCustomer, DmsVehicle} from "../../dms/event/model/vehicle";
import {SEARCH_LINKED_PROPOSALS} from "../action";
import type {DmsPart} from "../../dms/event/model/dmsOrders";

export type DmsOrder = {
	orderNumber: string,
	createdAt: string,
	customer: DmsCustomer,
	vehicle: DmsVehicle,
	parts: DmsPart[],
	state: string
}

export type DmsOrdersState = {
	orders: DmsOrder[],
	order: DmsOrder,
	isFetchingOrders: boolean,
	isFetchingOrder: boolean,
	isFetchingLinkedProposals: boolean,
	failedToFetchLinkedProposals: boolean,
	linkedProposals: { [dmsOrderNumber: string]: string },
}

const initialState: DmsOrdersState = {
	orders: [],
	order: null,
	isFetchingOrders: false,
	isFetchingOrder: false,
	isFetchingLinkedProposals: false,
	failedToFetchLinkedProposals: false,
	linkedProposals: {}
};

export const dmsOrders = (state = initialState, action) => {
	switch (action.type) {
		case DMS_ERROR:
			return {
				...state,
				isFetchingOrders: false,
				isFetchingOrder: false,
				orders: []
			};
		case DMS_ORDERS.REQUEST:
			return {
				...state,
				isFetchingOrders: true
			};
		case DMS_ORDERS.FOUND:
			return {
				...state,
				orders: action.payload,
				isFetchingOrders: false
			};
		case SEARCH_LINKED_PROPOSALS.REQUEST:
			return {
				...state,
				isFetchingLinkedProposals: true,
				failedToFetchLinkedProposals: false,
			};
		case SEARCH_LINKED_PROPOSALS.SUCCESS:
			return {
				...state,
				isFetchingLinkedProposals: false,
				failedToFetchLinkedProposals: false,
				linkedProposals: action.payload
			};
		case SEARCH_LINKED_PROPOSALS.FAILURE:
			return {
				...state,
				isFetchingLinkedProposals: false,
				failedToFetchLinkedProposals: true,
				linkedProposals: []
			};
		case DMS_ORDER_GET_BY_ID.REQUEST:
			return {
				...state,
				isFetchingOrder: true
			};
		case DMS_ORDER_GET_BY_ID.SUCCESS:
			// an answer which arrives after a timeout must not create a proposal the user was told had failed
			if (!state.isFetchingOrder) {
				return state;
			}
			return {
				...state,
				order: action.payload,
				isFetchingOrder: false
			};
		case DMS_ORDER_GET_BY_ID.NOT_FOUND:
		case DMS_ORDER_GET_BY_ID.TIMEOUT:
			return {
				...state,
				isFetchingOrder: false
			};
		default:
			return state;
	}
};
